<template>
    <section>
        <q-banner v-if="!fields.length" class="bg-grey-2 text-grey-8" rounded>
            No referral-specific information was found.
        </q-banner>
        <div v-else class="referral-specific-grid">
            <q-input
                v-for="field in fields"
                :key="field.originalFieldKey"
                :model-value="editableValue(field.reviewedValue)"
                :label="field.label"
                outlined
                dense
                autogrow
                type="textarea"
                placeholder="Not provided"
                hide-bottom-space
                @update:model-value="value => updateField(field.originalFieldKey, value)"
            />
        </div>
    </section>
</template>

<script>
import { displayReferralValue } from "@/services/util/referralWorkflow";

export default {
    name: "ReferralSpecificInformation",
    emits: ["update:field"],
    props: {
        fields: {
            type: Array,
            required: true,
        },
    },
    methods: {
        editableValue(value) {
            return value == null || value === "" ? "" : displayReferralValue(value);
        },
        updateField(fieldKey, value) {
            this.$emit("update:field", { fieldKey, value });
        },
    },
};
</script>

<style scoped>
.referral-specific-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}

@media (max-width: 700px) {
    .referral-specific-grid {
        grid-template-columns: 1fr;
    }
}
</style>
